"use client";

import Badge from "@/components/atoms/Badge";
import Visited from "@/components/molecules/Visited";
import { getPreviousApplication } from "@/helpers/cookies";
import { useTranslation } from "@/i18n/client";
import { AllowedLanguages } from "@/types/generic";

interface AppliedOrVisitedBadgeProps {
  isUrgent: boolean;
  jobId: string;
  locale: AllowedLanguages;
}

export const AppliedOrVisitedBadge = ({
  isUrgent,
  jobId,
  locale,
}: AppliedOrVisitedBadgeProps) => {
  const previousApplication = getPreviousApplication(jobId);
  const { t } = useTranslation(locale);

  const VisitedBadge = (
    <Badge color="brown" icon="eye">
      {t("pages.job.viewed")}
    </Badge>
  );

  return (
    <div className="flex justify-center gap-4 empty:hidden">
      {previousApplication ? (
        <Badge color="brown" icon="check">
          {t("pages.job.applied_on")}{" "}
          {new Date(previousApplication.date).toLocaleDateString(locale)}
        </Badge>
      ) : (
        <>
          {isUrgent && (
            <Badge color={"orange"} icon="fire">
              {t("pages.job.urgent")}
            </Badge>
          )}
          <Visited
            VisitedComponent={VisitedBadge}
            pageId={jobId}
            pageType={"job"}
          />
        </>
      )}
    </div>
  );
};

export default AppliedOrVisitedBadge;
